module.exports = __webpack_public_path__ + "media/images/icon-z-chan-5f5e8c922a2119cb00c85c06daa10621.png";